<template>
  <div class="text-center">

    <button 
      v-if="block.data.connectbox"
      @click="sendMessage" 
      :disabled="isDisabled" 
      :style="{
        backgroundColor: tourSettings.theme_color,
        color: tourSettings.theme_text_color
      }"
      :class="[
        'flex mx-auto my-5 py-2 px-6 rounded-full ',
        isDisabled ? 'opacity-40' : 'opacity-100'
      ]"
    >
      {{ $t('button.turn_on') }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../services/api'

export default {
  name: 'ConnectboxBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDisabled: false
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings'])
  },
 
  methods: {
    async sendMessage(e) {
      e.preventDefault()
      console.log("send a message")
      this.isDisabled = true
      
      const delay = this.block.data['delay'] || 0
      if (delay > 0) {
        setTimeout(() => {
          this.isDisabled = false
        }, delay * 1000)
      }

      try {
        // Send the connectbox message using the API service
        const response = await api.sendConnectboxMessage(
          this.block.data['connectbox']
        )
        
        console.log(response.data)
      } catch (error) {
        console.error('Error sending connectbox message:', error)
        // Re-enable button on error
        this.isDisabled = false
      }
    }
  }
}
</script>